import { Roles } from 'modules/core/enums';

export const ADMINS = [Roles.GLOBALADMIN, Roles.ADMIN];

export const ADMINS_AND_MANAGER = [...ADMINS, Roles.MANAGER];

export const ALL = [...ADMINS_AND_MANAGER, Roles.SALESPERSON];

export const MANAGER_AND_SALESPERSON = [Roles.MANAGER, Roles.SALESPERSON];
